import { useState, useCallback, useEffect } from 'react';

export interface Toast {
  id: string;
  title: string;
  description?: string;
  variant?: 'default' | 'destructive' | 'success';
}

let toastListeners: ((toasts: Toast[]) => void)[] = [];
let toasts: Toast[] = [];

const notify = () => {
  toastListeners.forEach((listener) => listener([...toasts]));
};

export function toast({ title, description, variant = 'default' }: Omit<Toast, 'id'>) {
  const id = Math.random().toString(36).substring(2, 9);
  toasts = [...toasts, { id, title, description, variant }];
  notify();

  setTimeout(() => {
    toasts = toasts.filter((t: Toast) => t.id !== id);
    notify();
  }, 4000);
}

export function useToast() {
  const [, setLocalToasts] = useState<Toast[]>([]);

  const dismiss = useCallback((id: string) => {
    toasts = toasts.filter((t: Toast) => t.id !== id);
    notify();
  }, []);

  useEffect(() => {
    const listener = (updatedToasts: Toast[]) => setLocalToasts(updatedToasts);
    toastListeners.push(listener);
    return () => {
      toastListeners = toastListeners.filter((l) => l !== listener);
    };
  }, []);

  return { toasts, dismiss };
}
